import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DataService, HelperService, HTTPService, SharedService,SocketService } from 'app/services';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Subject } from 'rxjs';
import { events } from 'app/constants/socket-events';

import { takeUntil } from 'rxjs/operators';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { TranslateService } from '@ngx-translate/core';
import { lowerCase } from 'lodash';

@Component({
  selector: 'app-technician-dismiss-dialog',
  templateUrl: './technician-dismiss-dialog.component.html',
  styleUrls: ['./technician-dismiss-dialog.component.scss']
})
export class TechnicianDismissDialogComponent implements OnInit {
  socketListener: Subject<boolean> = new Subject<boolean>();
  techId: string = '';
  unreadAlerts:any ;
  data: any = {};
  currentLang: string = 'en';

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dialogService: DialogService,
    private socketService: SocketService,
    private dialogConfig: DynamicDialogConfig,
     private dynamicDialogRef: DynamicDialogRef,
     private dataService: DataService,
     private translate: TranslateService
  ) { }

  ngOnInit( ) {
    this.data = this.dialogConfig.data;
    this.unreadAlerts = this.data.unreadAlerts;
    this.techId = this.data.techId;
    this.getPreferredLanguage();
    

    this.socketService
    .socketOn(`tech_popupClose${this.techId}`)
    .pipe(takeUntil(this.socketListener))
    .subscribe((data) => {
      this.dialogService.dialogComponentRefMap.forEach(dialog => {
        dialog.destroy();
      })
    });
  }

  getTranslatedText(value: string) {
    if(this.currentLang === 'fr') {
      const text = lowerCase(value)
      if(text === 'completed') {
        return 'Complété';
      } else if (text === 'started') {
        return 'Commencé';
      } else if (text === 'resumed') {
        return 'Repris';
      } else if (text === 'restarted') {
        return 'Redémarré';
      } else if (text === 'paused') {
        return 'En pause';
      }
    }
    return value;
    
  }

  async getPreferredLanguage() {
    try {
      const res: any = await this.httpService.getCompanyPreferredLanguage();
      const companyLocalization = res.localization;
      if (companyLocalization) {
        const user = this.helperService.getCompany();

        const employee: { preferredLanguage?: string } = await this.httpService.getEmployeeDetails(user.employeeId);
        if (employee.preferredLanguage) {
          this.currentLang = lowerCase(employee.preferredLanguage) || 'en';
        }
      } else {
        this.currentLang = 'en';
      }
    } catch (error) {
      console.log('Error: ', error);
    } finally {
      this.translate.use(this.currentLang);
    }
  }

  dismissDialog() {
    const body = {
      ids: [],
    };
    this.unreadAlerts.forEach((item) => {
      if (!item.isSeen) {
        body.ids.push(item._id);
      }
    });
    if (body.ids.length) {
      const data = {
        ids: body.ids,
        isDialogClose: true,
        techId:this.techId
      }
      this.httpService.UpdateNotificationsStatus(data).then(
        (res) => {
          this.dialogService.dialogComponentRefMap.forEach(dialog => {
            dialog.destroy();
          })
        },
        (error) => {
          this.helperService.showToaster('error', error);
        }
      );
    }

  }

  ngOnDestroy() {
    if (this.socketListener) {
      this.socketListener.unsubscribe();
    }
  }

}



